import { axios } from "@/plugins/axios";

async function IsMaintenance() {
    return axios.post("?Mode=MeinServicebereich&Function=IsMaintenance");
}

async function IsMaintenanceApp() {
    return axios.post("?Mode=MeinServicebereich&Function=IsMaintenanceApp");
}

export { IsMaintenance, IsMaintenanceApp };
